import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, {} from 'react';
import { Dropdown, Button, Space } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import { userHasPermission } from "../../../swzutils/UserPermissionsUtil";
import { conditionFilter } from "../../../swzutils";
import { useAppSelector } from "../../../store";
import { loggedInUserSelector } from "../../../store/slice/auth";
const PermissionDropdownButton = ({ label, disabled, onClick, route, condition = true, permissions, menuItems, className, placement = "bottomRight" }) => {
    const loggedInUser = useAppSelector(loggedInUserSelector);
    function permissionFilter(menuItem) {
        if (menuItem.permissions && menuItem.permissions.length > 0) {
            return userHasPermission(loggedInUser, menuItem.permissions);
        }
        return true;
    }
    function onMenuItemClicked(e, menuItem) {
        if (typeof menuItem.onClick == "function") {
            e.stopPropagation(); // Otherwise table will toggle show / collapse
            menuItem.onClick();
        }
    }
    function hasMainPermissions() {
        if (permissions && permissions.length) {
            return userHasPermission(loggedInUser, permissions);
        }
        return true;
    }
    function filteredMenuItems() {
        return menuItems
            .filter(permissionFilter)
            .filter(conditionFilter)
            .map(menuItem => {
            return {
                label: _jsx("a", { target: menuItem.target, href: menuItem.route, onClick: (e) => onMenuItemClicked(e, menuItem), children: menuItem.label }),
                key: menuItem.key,
                icon: menuItem.icon
            };
        });
    }
    const dropdownMenuItems = filteredMenuItems();
    if (dropdownMenuItems?.length > 0) {
        if (((onClick || route) && condition && hasMainPermissions())) {
            return (_jsxs(Space.Compact, { children: [_jsx(Button, { onClick: route ? undefined : onClick, href: route, children: label }), _jsx(Dropdown, { className: className, destroyOnHidden: true, disabled: disabled, placement: placement, menu: {
                            items: dropdownMenuItems
                        }, children: _jsx(Button, { icon: _jsx(CaretDownOutlined, {}) }) })] }));
        }
        else {
            return (_jsx(Dropdown, { destroyOnHidden: true, disabled: disabled, placement: placement, menu: {
                    items: dropdownMenuItems
                }, children: _jsx(Button, { icon: _jsx(CaretDownOutlined, {}) }) }));
        }
    }
    else if (hasMainPermissions() && condition && label) {
        return (_jsx(Button, { href: route, onClick: onClick, children: label }));
    }
    return null;
};
export default PermissionDropdownButton;
